export default "__VITE_ASSET__DmUi_Dso__"